import { useEffect } from 'react';
import { useAuthStore } from './useAuthStore';
import { api, refreshAccessToken, logoutSession } from '../services/api';
import { setAppLanguage } from '../utils/i18nSync';

/** Restore access token from httpOnly refresh cookie on page load and sync language. */
export function useInitAuth() {
  const user = useAuthStore((s) => s.user);
  const accessToken = useAuthStore((s) => s.accessToken);
  const updateUser = useAuthStore((s) => s.updateUser);

  useEffect(() => {
    if (user?.role === 'admin') {
      void logoutSession();
    }
  }, [user?.role]);

  useEffect(() => {
    if (user && !accessToken) {
      void refreshAccessToken();
    }
  }, [user, accessToken]);

  useEffect(() => {
    if (!user?.id || !accessToken) return;
    void api
      .get<{
        firstName?: string | null;
        phone?: string;
        preferredLanguage?: string;
      }>('/auth/profile')
      .then((profile) => {
        updateUser({
          firstName: profile.firstName ?? null,
          phone: profile.phone,
          preferredLanguage: profile.preferredLanguage,
        });
      })
      .catch(() => undefined);
  }, [user?.id, accessToken, updateUser]);

  useEffect(() => {
    if (user?.preferredLanguage) {
      setAppLanguage(user.preferredLanguage);
    }
  }, [user?.preferredLanguage]);
}
